import React, { useState } from "react";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from "recharts";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, MenuItem, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";

function RevenueAnalytic() {
  const [timeRange, setTimeRange] = useState("day");
  const navigate=useNavigate();
  // Example data (replace with API later)
  const revenueData = [
    { name: "Mon", revenue: 1200, orders: 12 },
    { name: "Tue", revenue: 2100, orders: 21 },
    { name: "Wed", revenue: 1800, orders: 18 },
    { name: "Thu", revenue: 3000, orders: 30 },
    { name: "Fri", revenue: 2600, orders: 26 },
    { name: "Sat", revenue: 1400, orders: 14 },
    { name: "Sun", revenue: 1700, orders: 17 },
  ];



  return (
    <>
      <div className="main_title">
        <h1>Revenue Analytics</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Revenue Analytics
        </p>
      </div>

      <div className="grid_sc gap_m">
        {/* Orders Chart */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Subscriptions</h2>
            </div>
            <div className="right_s form">
              <Select
                value={timeRange}
                onChange={(e) => setTimeRange(e.target.value)}
                size="small"
              >
                <MenuItem value="day">A Day</MenuItem>
                <MenuItem value="month">A Month</MenuItem>
                <MenuItem value="year">A Year</MenuItem>
                <MenuItem value="custom">Custom</MenuItem>
              </Select>
              <Button className="btn btn_black icon_btn" >
                <FileDownloadIcon />
              </Button>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="orders" fill="#38B6FF" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Revenue Chart */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Revenue</h2>
            </div>
            <div className="right_s form">
              <Select
                value={timeRange}
                onChange={(e) => setTimeRange(e.target.value)}
                size="small"
              >
                <MenuItem value="day">A Day</MenuItem>
                <MenuItem value="month">A Month</MenuItem>
                <MenuItem value="year">A Year</MenuItem>
                <MenuItem value="custom">Custom</MenuItem>
              </Select>
              <Button className="btn btn_black icon_btn">
                <FileDownloadIcon />
              </Button>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="revenue" fill="#FF8238" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
}

export default RevenueAnalytic;
